<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <div class="box text-center">
          <!-- /.box-header -->
          <div class="del-block m-t-5" v-if="up">
            <div class="btn btn-danger" data-toggle="modal" data-target="#delModal">
              <i class="fa fa-trash"></i>
            </div>
          </div>
          <div class="copy-block m-t-5" v-if="up">
            <router-link :to="'/copyLimiScheduleItem/' + $route.params.setting_id  + '?brand_id=' + $route.query.brand_id + '&store_id=' + $route.query.store_id">
              <button class="btn btn-default">複製門市限時限量設定</button>
            </router-link>
          </div>
          <div class="box-body form">
            <br />
            <div>
              <h3 style="margin-bottom: 3em">
                基本設定
              </h3>
              <div>
                <div class="text-left m-b-15">
                  <span class="text-red">*</span>
                  <span>若限量條件重複，會以滿足條件的最小值為主。</span>
                </div>
                <!-- 品牌 -->
                <div class="input-group" v-if="brandBrief.length > 1 || up">
                  <span class="input-group-addon" style="min-width: 138px; text-align: left;">
                    <span class="text-red">＊ </span>品牌
                  </span>
                  <multiselect v-if='!up' v-model="brandSelect" :options="brandBrief" :searchable="true"
                    :allow-empty="false" :close-on-select="true" placeholder="==品牌==" :show-labels="false"
                    :multiple="false" label="label" track-by="value" :disable="true" @input="routerEvent('brand')">
                  </multiselect>
                  <div v-if='up' class="form-control form-info text-left">
                    {{brandSelect.label}}
                  </div>
                </div>
                <br />
                <!-- 門市 -->
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon" style="min-width: 138px; text-align: left;">
                    <span class="text-red">＊ </span>門市
                  </span>
                  <multiselect v-if='!up' v-model="storeSelect" :options="storeBrief" :searchable="true"
                    :allow-empty="false" :close-on-select="true" placeholder="== 門市 ==" :show-labels="false"
                    :multiple="false" label="label" track-by="value" @input="routerEvent('store')">
                  </multiselect>
                  <div v-if='up' class="form-control form-info text-left">
                    {{storeSelect.label}}
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon" style="min-width: 138px; text-align: left;">
                    設定名稱
                  </span>
                  <input class="form-control" placeholder="備註用，不會顯示在菜單" type="text" v-model="name" maxlength="16">
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon" style="min-width: 138px; text-align: left;">
                    設定描述
                  </span>
                  <input class="form-control" placeholder="備註用，不會顯示在菜單" type="text" v-model="description"
                    maxlength="200">
                </div>
                <br />
              </div>
              <!-- 商品列表 -->
              <br>
              <div>
                <h3 style="margin-top: 2em; margin-bottom: 1em;">
                  指定區間設定
                </h3>
                <div class="text-left">
                  <button class="btn btn-success" @click="addSectionSetting">新增指定區間設定</button>
                </div>
                <div class="box-table" style="height:400px; min-height: 300px;">
                  <div style="height: 100%;">
                    <div class="col-sm-12 p-x-0  position-relative" style="height: 100%;">
                      <table class="table table-striped dataTable"
                        :class="show_section_overlap ? 'table-borderless' : 'table-bordered'">
                        <thead class="bg-primary position-sticky">
                          <tr>
                            <td>取貨方式</td>
                            <td>指定區間</td>
                            <td>開始時間</td>
                            <td>結束時間</td>
                            <td>限量單位</td>
                            <td>數量上限</td>
                            <td>開啟狀態</td>
                            <td>操作</td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(section, sIndex) in rule_section_list" :key="sIndex +' week'"
                            :class="section.show_overlap ? 'overlap' : ''">
                            <td :style="show_section_overlap ? 'vertical-align: middle' : ''">
                              <div class="">
                                <select class="form-control min-w p-0" v-model="section.delivery_type">
                                  <option value=0>不限</option>
                                  <option v-for="main in storedeliveryInfo" :value="main.value">
                                    {{main.label}}
                                  </option>
                                </select>
                              </div>
                            </td>
                            <td :style="show_section_overlap ? 'vertical-align: middle' : ''">
                              <div style="display: flex; justify-content: center;">
                                <div>
                                  <date-time-picker @change="changeDate($event, 'start', sIndex)" placeholder="YYYMM-DD"
                                    :date="section.sectionTime.start" :option="dateoption"
                                    :limit="section.startLimit"></date-time-picker>
                                </div>
                                <div style="margin-left: 4px; margin-right: 4px; align-self: center">
                                  -
                                </div>
                                <div>
                                  <date-time-picker @change="changeDate($event,'end', sIndex)" placeholder="YYYMM-DD"
                                    :date="section.sectionTime.end" :option="dateoption"
                                    :limit="section.endLimit"></date-time-picker>
                                </div>
                              </div>
                            </td>
                            <td class="text-center" :style="show_section_overlap ? 'vertical-align: middle' : ''">
                              <vue-timepicker hide-disabled-items v-model="section.rule_start_time" manual-input
                                placeholder="hh:mm" :minute-interval="30" input-class="form-control"></vue-timepicker>
                            </td>
                            <td class="text-center" :style="show_section_overlap ? 'vertical-align: middle' : ''">
                              <vue-timepicker hide-disabled-items v-model="section.rule_end_time" manual-input
                                placeholder="hh:mm" :minute-range="[29, 59]" input-class="form-control"></vue-timepicker>
                            </td>
                            <td :style="show_section_overlap ? 'vertical-align: middle' : ''">
                              <div>
                                <select class="form-control min-w p-0" v-model="section.src_type">
                                  <option value=1>訂單</option>
                                  <option value=2>份數</option>
                                </select>
                              </div>
                            </td>
                            <td class="text-center">
                              <input v-model="section.amount" type="number"
                                style="max-width: 86px; height: 34px; border: 1px solid #d2d6de; border-radius: 0px 3px 3px 0px; padding-left: 4px">
                            </td>
                            <td style="vertical-align: middle; min-width: 100px;">
                              <div class="text-left">
                                <div class="radio inline-block">
                                  <label>
                                    <input type="radio" v-model="section.is_enabled" value=1>
                                    開啟
                                  </label>
                                </div>
                                <div class="radio inline-block" style="margin-top: 0px">
                                  <label>
                                    <input type="radio" v-model="section.is_enabled" value=0>
                                    關閉
                                  </label>
                                </div>
                              </div>
                            </td>
                            <td style="text-align: center;" :style="show_section_overlap ? 'vertical-align: middle' : ''">
                              <div class="btn btn-danger" @click="removeListItem(rule_section_list, sIndex)">
                                <i class="fa fa-trash"></i>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <h3 style="margin-bottom: 1em; margin-top: 2em;">
                週期設定
              </h3>
              <div class="text-left">
                <button class="btn btn-success" @click="addWeekSetting">新增週期設定</button>
              </div>
              <div class="box-table" style="height:500px; min-height: 300px;">
                <div style="height: 100%;">
                  <div class="col-sm-12 p-x-0 position-relative" style="height: 100%;">
                    <table class="table table-striped dataTable"
                      :class="show_section_overlap ? 'table-borderless' : 'table-bordered'">
                      <thead class="bg-primary position-sticky">
                        <tr>
                          <td>取貨方式</td>
                          <td>指定區間</td>
                          <td>開始時間</td>
                          <td>結束時間</td>
                          <td>限量單位</td>
                          <td>數量上限</td>
                          <td>開啟狀態</td>
                          <td>操作</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in rule_week_list"
                          :key="item.id"
                          :class="{ 'overlap': item.show_overlap }"
                        >
                          <td>
                            <select class="form-control min-w p-0" v-model="item.delivery_type">
                              <option value=0>不限</option>
                              <option v-for="main in storedeliveryInfo" :value="main.value">
                                {{ main.label }}
                              </option>
                            </select>
                          </td>
                          <td>
                            <select
                              required
                              class="form-control min-w p-0"
                              :style="item.rule_day === '' ? 'color: rgb(149,149,149)' : ''"
                              v-model="item.rule_day"
                            >
                              <option disabled value="" selected>星期</option>
                              <option value=1>週日</option>
                              <option value=2>週一</option>
                              <option value=3>週二</option>
                              <option value=4>週三</option>
                              <option value=5>週四</option>
                              <option value=6>週五</option>
                              <option value=7>週六</option>
                            </select>
                          </td>
                          <td>
                            <input type="time" v-model="item.rule_start_time" class="form-control">
                          </td>
                          <td>
                            <input type="time" v-model="item.rule_end_time" class="form-control">
                          </td>
                          <td>
                            <select class="form-control min-w p-0" v-model="item.src_type">
                              <option value=1>訂單</option>
                              <option value=2>份數</option>
                            </select>
                          </td>
                          <td class="text-center">
                            <input
                              v-model="item.amount"
                              type="number"
                              min=1
                              style="max-width: 86px; height: 34px; border: 1px solid #d2d6de; border-radius: 0px 3px 3px 0px; padding-left: 4px"
                            >
                          </td>
                          <td class="text-center" style="vertical-align: middle; min-width: 100px;">
                            <div class="text-left">
                              <div class="radio inline-block">
                                <label><input type="radio" v-model="item.is_enabled" value=1> 開啟</label>
                              </div>
                              <div class="radio inline-block" style="margin-top: 0px">
                                <label><input type="radio" v-model="item.is_enabled" value=0> 關閉</label>
                              </div>
                            </div>
                          </td>
                          <td class="text-center">
                            <button class="btn btn-danger" @click="removeListItem(rule_week_list, index)">
                              <i class="fa fa-trash"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="box-footer text-center">
            <button @click="$router.go(-1)" class="btn btn-fail text-black">
              返回
            </button>
            <button class="btn btn-success" v-text="checkSettingText" @click="checkSetting()" />
          </div>
        </div>
      </div>
    </div>
    <m-modal :option="delOption" @trigger="trigger"></m-modal>

    <m-modal :class="[{ 'in show': checkedFormModal }]" :option="checkedFormModalOption" @trigger="trigger" />
  </section>
</template>

<script>
// Require needed datatables modules
import { mapGetters } from 'vuex'
import moment from 'moment'
import datetimePicker from 'vue-datepicker/vue-datepicker-es6.vue'
import VueTimepicker from 'vue2-timepicker'

export default {
  components: {
    'date-time-picker': datetimePicker,
    VueTimepicker
  },
  data () {
    return {
      menuState: 4,
      name: '',
      description: '',
      total: 1,
      count: 20,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      scheduleList: [],
      bindList: [],
      is_enabled: 1,
      vendor_custom_id: '',
      alias_name: '',
      prod_description: '',
      prod_description_list: [{ prod_description: '' }],
      addAmount: 5,
      settingId: '',
      type: 1, // 1 = 小圖， 2 = 大圖
      currentId: '',
      smImgSrc: '',
      up: false,
      enableOption: [
        {label: '啟用', value: 1},
        {label: '關閉', value: 0}
      ],
      delOption: {
        id: 'delModal',
        title: '刪除限時限量設定',
        body: '',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'delLimitAmount'
          }
        ]
      },
      delItemOption: {
        id: 'delModal',
        title: '刪除商品設定',
        body: '',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'delDisableScheduleItem'
          }
        ]
      },
      // time
      sectionTime: {
        start: {
          time: ''
        },
        end: {
          time: ''
        }
      },
      startTime: {
        time: ''
      },
      endtime: {
        time: ''
      },
      dateoption_rule: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: 'YYYYMM-DD',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px 12px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555',
          'width': '248px',
          'min-width': '248px',
          'text-align': 'left'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: 'YYYY-MM-DD',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px 0px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'width': '97px',
          'min-width': '97px',
          'text-align': 'center'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      startLimit: [
        {
          type: 'fromto',
          from: moment().add(-1, 'day').format('YYYY-MM-DD')
        }
      ],
      endLimit: [
        {
          type: 'fromto',
          from: moment().add(-1, 'day').format('YYYY-MM-DD')
        }
      ],
      limit_rule: [
        {
          type: 'fromto',
          from: moment().add(-1, 'day').format('YYYY-MM-DD HH:mm:ss')
        }
      ],
      deliveryTypeOption: [
        { label: '全部', value: 0 },
        { label: '自取', value: 1 },
        { label: '內用', value: 2 },
        { label: '外送', value: 3 },
        { label: '外帶', value: 4 },
        { label: '吧台', value: 5 },
        { label: '內用-桌邊掃碼', value: 21 }
      ],
      srcIdTypeOptions: [
        { label: '廠商料號', value: 1 },
        { label: '平台商品ID', value: 2 }
      ],
      item_list: [],
      rule_list: [],
      rule_section_list: [],
      rule_week_list: [],
      ruleTypeOptions: [
        { label: '每日', value: 0 },
        { label: '指定日期', value: 1 },
        { label: '指定星期', value: 2 },
        { label: '每月幾號', value: 3 }
      ],
      offdaySetting: {
        options: {
          weekDay: [
            {label: '週日', value: 1},
            {label: '週一', value: 2},
            {label: '週二', value: 3},
            {label: '週三', value: 4},
            {label: '週四', value: 5},
            {label: '週五', value: 6},
            {label: '週六', value: 7}
          ]
        }
      },
      brandSelect: {
        value: 999999,
        label: '==品牌=='
      },
      storeSelect: {
        value: null,
        label: ''
      },
      // 影響菜單是否能讀取到店家
      brandBrief: [],
      storeBrief: [],
      addStoresSetting: {
        options: [],
        choose: []
      },
      // 停賣菜單
      menuId: null,
      brandId: null,
      category: [],
      product: [],
      prodNumList: {},
      menuInfo: {},
      menuList: '',
      // if created checkbox all true, if not all false
      created: false,
      getTimes: 0,
      time: 0,
      accessory: [],
      disTableList: [],
      adjustCheckbox: false,
      options: [],
      show_section_overlap: false,
      show_week_overlap: false,
      store_deliveryInfo: [],
      checkedForm: false,
      checkedFormModal: false,
      checkedFormModalOption: {
        id: 'checkedFormModal',
        title: '設定重複，請確認紅框處。',
        body: '',
        btns: [
          {
            name: '確定',
            event: 'checkedFormSubmit'
          }
        ]
      }
    }
  },
  methods: {
    validateHhMm (inputField) {
      var isValid = /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/.test(inputField.value)
      return isValid
    },
    changeDate (event, from, index) {
      // startlimit endLimit
      if (from === 'start') {
        const sdate = new Date(this.rule_section_list[index].sectionTime.start.time)
        let startdate = new Date(sdate)
        startdate.setDate(startdate.getDate() - 1)
        this.rule_section_list[index].endLimit[0].from = startdate.toISOString().split('T')[0]
        if (this.rule_section_list[index].sectionTime.end.time !== '') {
          if (this.rule_section_list[index].sectionTime.end.time < this.rule_section_list[index].sectionTime.start.time) {
            const date = new Date(this.rule_section_list[index].sectionTime.start.time)
            let enddate = new Date(date)
            enddate.setDate(enddate.getDate() + 1)
            this.rule_section_list[index].sectionTime.end.time = enddate.toISOString().split('T')[0]
          }
        }
      }
      // else if (from === 'end') {
      //   if (event < this.rule_section_list[index].sectionTime.start) {
      //     const date = new Date(event)
      //     let enddate = new Date(date)
      //     enddate.setDate(enddate.getDate() - 1)
      //     this.rule_section_list[index].sectionTime.start = enddate.toISOString().split('T')[0]
      //   }
    },
    routerEvent (event) {
      if (event === 'brand') {
        this.storeBrief = []
        this.rule_section_list = []
        this.rule_week_list = []
        this.storeSelect = {
          value: null,
          label: ''
        }
        let queryValue = {}
        queryValue = {...queryValue, ...{brand_id: this.brandSelect.value}}
        this.$router.push({query: queryValue})
        this.getStoreLimitSetting(this.brandSelect.value)
      } else if (event === 'store') {
        let queryValue = {}
        queryValue = {...queryValue, ...{store_id: this.storeSelect.value, brand_id: this.brandSelect.value}}
        this.$router.push({query: queryValue})
        if (this.storeSelect.value) {
          this.getStoreInfo(this.$route.query.store_id)
        }
      }
    },
    getStoreInfo (storeID) {
      const self = this
      const url = '/store/' + storeID + '/info'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.store_deliveryInfo = response.data.info.delivery_info
          self.store_deliveryInfo = self.store_deliveryInfo.filter((value, index, self) =>
            index === self.findIndex((t) => (
              t.delivery_type === value.delivery_type
            ))
          )
        }
      })
    },
    delLimitAmount () {
      var self = this
      var url = '/storeOrderAmountLimitSetting/' + this.$route.params.setting_id
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '成功',
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.$router.go(-1)
        }
      })
    },
    trigger (event) {
      if (event === 'delLimitAmount') {
        if (this.$route.name === 'upLimitScheduleItem') this.delLimitAmount()
      }
      if (event === 'checkedFormSubmit') {
        this.checkedFormModal = false
      }
    },
    getBrandBrief () {
      const self = this
      const url = '/brand/listBrief?is_delete=0&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list
          for (let i = 0; i < bList.length; i++) {
            let obj = {label: bList[i].name, value: bList[i].brand_id}
            if (!bList[i].is_visible) obj.label = obj.label + ' (測)'
            self.brandBrief.push(obj)
            if (self.$route.name === 'crLimitScheduleItem' && (self.getRoleType === 99 || self.getRoleType === 30 || self.getRoleType === 10)) {
              if (Number(self.$route.query.brand_id) === obj.value) {
                self.brandSelect = obj
                self.getStoreLimitSetting(self.$route.query.brand_id)
              }
            } else if (i === 0 && self.$route.params.usage_type !== 2) {
              self.brandSelect = obj
            }
          }
        }
      })
    },
    // 需選用剔除已設定門市
    getStoreBrief (brandId) {
      console.log('getStoreBrief | LimScheduleProdTemp')
      var self = this
      self.storeBrief = []
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            self.storeBrief.push(obj)
            if (self.$route.name === 'crLimitScheduleItem' && (self.getRoleType === 99 || self.getRoleType === 30 || self.getRoleType === 10)) {
              if (Number(self.$route.query.store_id) === obj.value) {
                self.storeSelect = obj
                self.getStoreInfo(obj.value)
              }
            }
          }
        }
      })
    },
    getStoreLimitSetting (brandId) {
      var self = this
      self.storeBrief = []
      var url = '/storeOrderAmountLimitSetting/getStoreList?brand_id=' + brandId + '&type=create'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.store_list
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].store_name, value: sList[i].store_id}
            self.storeBrief.push(obj)
            if (self.$route.name === 'crLimitScheduleItem' && (self.getRoleType === 99 || self.getRoleType === 30 || self.getRoleType === 10)) {
              if (Number(self.$route.query.store_id) === obj.value) {
                self.storeSelect = obj
                self.getStoreInfo(obj.value)
              }
            }
          }
        }
      })
    },
    // 門市限時限量
    addSectionSetting () {
      if (this.storeSelect.value) {
        const setting = {
          rule_type: 1,
          rule_start_date: null,
          rule_end_date: null,
          rule_start_time: '',
          rule_end_time: '',
          amount: 1,
          is_enabled: 1,
          sectionTime: {
            start: {
              time: ''
            },
            end: {
              time: ''
            }
          },
          show_overlap: false,
          src_type: 2,
          delivery_type: 0,
          startLimit: [
            {
              type: 'fromto',
              from: moment().add(-1, 'day').format('YYYY-MM-DD')
            }
          ],
          endLimit: [
            {
              type: 'fromto',
              from: moment().add(-1, 'day').format('YYYY-MM-DD')
              // from: setting.sectionTime.start.time || moment().format('YYYY-MM-DD HH:mm:ss')
            }
          ]
        }
        // setting.endLimit.from = setting.sectionTime.start.time
        this.rule_section_list.push(setting)
      } else {
        this.$notify({
          title: '提醒',
          text: '請選擇門市',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      }
    },
    addWeekSetting () {
      if (this.storeSelect.value) {
        const setting = {
          rule_type: 2,
          rule_day: '',
          rule_start_time: '',
          rule_end_time: '',
          amount: 1,
          is_enabled: 1,
          show_overlap: false,
          src_type: 2,
          delivery_type: 0,
          id: this.rule_week_list.length
        }
        this.rule_week_list.push(setting)
      } else {
        this.$notify({
          title: '提醒',
          text: '請選擇門市',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      }
    },
    // 門市限時限量
    removeListItem (list, index) {
      list.splice(index, 1)
    },
    addRule () {
      const rule = { rule_type: { label: '每日', value: 0 }, rule_date: {time: ''}, rule_day: '', rule_month_day: '', rule_start_time: '', rule_end_time: '' }
      this.rule_list.push(rule)
    },
    checkSetting () {
      if (this.checkedForm) {
        this.submit()
        return
      }

      let msg = ''
      const self = this
      if (!this.storeSelect.value) {
        msg = '請選擇門市'
        this.getToast(msg)
      } else if (this.rule_section_list.length === 0 && this.rule_week_list.length === 0) {
        msg = '" 新增指定區間設定或者週期設定 " 未新增 請填寫'
        this.getToast(msg)
      } else {
        if (self.rule_section_list) {
          self.rule_section_list.forEach(item => {
            item.show_overlap = false
            self.show_section_overlap = false
          })
        }
        if (self.rule_week_list) {
          self.rule_week_list.forEach(item => {
            if (moment(item.rule_start_time, 'HH:mm', true).isValid()) item.rule_start_time = moment(item.rule_start_time, 'HH:mm', true).format('HH:mm:ss')
            if (moment(item.rule_end_time, 'HH:mm', true).isValid()) item.rule_end_time = moment(item.rule_end_time, 'HH:mm', true).format('HH:mm:ss')
            item.show_overlap = false
            self.show_week_overlap = false
          })
        }
        if (self.rule_section_list) {
          self.rule_section_list.forEach(function (item, i) {
            if (!item.sectionTime.start.time) {
              msg = ' " 指定區間 " 未填寫 請填寫'
              self.show_section_overlap = true
              item.show_overlap = true
            } else if (!item.sectionTime.end.time) {
              msg = ' " 指定區間 " 未填寫 請填寫'
              self.show_section_overlap = true
              item.show_overlap = true
            } else if (!item.rule_start_time || !moment(item.rule_start_time, 'HH:mm', true).isValid()) {
              msg = ' " 開始時間 " 未填寫 請填寫'
              self.show_section_overlap = true
              item.show_overlap = true
            } else if (!item.rule_end_time || !moment(item.rule_end_time, 'HH:mm', true).isValid()) {
              msg = ' " 結束時間 " 未填寫 請填寫'
              self.show_section_overlap = true
              item.show_overlap = true
            } else if (!item.amount || item.amount === 0) {
              msg = ' " 數量上限 " 未填寫 請填寫'
              self.show_section_overlap = true
              item.show_overlap = true
            } else if (item.sectionTime.start.time > item.sectionTime.end.time) {
              msg = '開始日大於結束日'
              self.show_section_overlap = true
              item.show_overlap = true
            } else if (item.rule_start_time > item.rule_end_time) {
              msg = '開始時間大於結束時間'
              self.show_section_overlap = true
              item.show_overlap = true
            }
            // 判斷是否啟用
            if (item.is_enabled === 1 || item.is_enabled === '1') {
              const date1 = item.sectionTime.start.time
              const date2 = item.sectionTime.end.time
              const time1 = item.rule_start_time
              const time2 = item.rule_end_time
              for (let step = self.rule_section_list.length - 1; step > i; step--) {
                if (!self.rule_section_list[step].sectionTime.start.time) {
                  msg = ' " 指定時間 " 未填寫 請填寫'
                  self.show_section_overlap = true
                  self.rule_section_list[step].show_overlap = true
                } else if (!self.rule_section_list[step].sectionTime.end.time) {
                  msg = ' " 指定時間 " 未填寫 請填寫'
                  self.show_section_overlap = true
                  self.rule_section_list[step].show_overlap = true
                } else if (!self.rule_section_list[step].rule_start_time || !moment(self.rule_section_list[step].rule_start_time, 'HH:mm', true).isValid()) {
                  msg = ' " 開始時間 " 未填寫 請填寫'
                  self.show_section_overlap = true
                  self.rule_section_list[step].show_overlap = true
                } else if (!self.rule_section_list[step].rule_end_time || !moment(self.rule_section_list[step].rule_end_time, 'HH:mm', true).isValid()) {
                  msg = ' " 結束時間 " 未填寫 請填寫'
                  self.show_section_overlap = true
                  self.rule_section_list[step].show_overlap = true
                } else if (!self.rule_section_list[step].amount || self.rule_section_list[step].amount === 0) {
                  msg = ' " 數量上限 " 未填寫 請填寫'
                  self.show_section_overlap = true
                  self.rule_section_list[step].show_overlap = true
                } else {
                  // 判斷是否啟用
                  if (self.rule_section_list[step].is_enabled === 1 || self.rule_section_list[step].is_enabled === '1') {
                    // 判斷取餐方式是否相同
                    if (self.rule_section_list[step].delivery_type === item.delivery_type || self.rule_section_list[step].delivery_type === 0 || item.delivery_type === 0) {
                      const edate1 = self.rule_section_list[step].sectionTime.start.time
                      const edate2 = self.rule_section_list[step].sectionTime.end.time
                      const etime1 = self.rule_section_list[step].rule_start_time
                      const etime2 = self.rule_section_list[step].rule_end_time
                      if (self.dateRangeOverlaps(date1, date2, edate1, edate2) === true) {
                        if (self.dateRangeOverlaps(time1, time2, etime1, etime2) === true) {
                          // 時間有發生重疊
                          msg = ''
                          self.show_section_overlap = true
                          self.rule_section_list[step].show_overlap = true
                          self.rule_section_list[i].show_overlap = true
                          self.checkedFormEvnet()
                        }
                      }
                    }
                  }
                }
              }
              self.rule_week_list.forEach(function (itemW, wi) {
                if (!itemW.rule_day) {
                  msg = ' " 星期 " 未填寫 請填寫'
                  self.show_week_overlap = true
                  itemW.show_overlap = true
                } else if (!itemW.rule_start_time || !moment(itemW.rule_start_time, 'HH:mm', true).isValid()) {
                  msg = ' " 開始時間 " 未填寫 請填寫'
                  self.show_week_overlap = true
                  itemW.show_overlap = true
                } else if (!itemW.rule_end_time || !moment(itemW.rule_end_time, 'HH:mm', true).isValid()) {
                  msg = ' " 結束時間 " 未填寫 請填寫'
                  self.show_week_overlap = true
                  itemW.show_overlap = true
                } else if (!itemW.amount || !item.amount === 0) {
                  msg = ' " 數量上限 " 未填寫 請填寫'
                  self.show_week_overlap = true
                  itemW.show_overlap = true
                } else {
                  if (itemW.is_enabled === 1 || itemW.is_enabled === '1') {
                    if (itemW.delivery_type === item.delivery_type || itemW.delivery_type === 0 || item.delivery_type === 0) {
                      const date1a = new Date(date1)
                      const date2a = new Date(date2)
                      if (self.weekRange(date1a, date2a, Number(itemW.rule_day)) === true) {
                        if (self.dateRangeOverlaps(time1, time2, itemW.rule_start_time, itemW.rule_end_time) === true) {
                          // 時間有發生重疊
                          msg = ''
                          self.show_week_overlap = true
                          self.show_section_overlap = true
                          self.rule_week_list[wi].show_overlap = true
                          self.rule_section_list[i].show_overlap = true
                          self.checkedFormEvnet()
                        }
                      }
                    }
                  }
                }
              })
            }
          })
        }
        // overlapping
        if (this.rule_week_list) {
          this.rule_week_list.forEach(function (item, wi) {
            if (!item.rule_day) {
              msg = ' " 星期 " 未填寫 請填寫'
              self.show_week_overlap = true
              item.show_overlap = true
            } else if (!item.rule_start_time || !moment(item.rule_start_time, 'HH:mm:ss', true).isValid()) {
              msg = ' " 開始時間 " 未填寫 請填寫'
              self.show_week_overlap = true
              item.show_overlap = true
            } else if (!item.rule_end_time || !moment(item.rule_end_time, 'HH:mm:ss', true).isValid()) {
              msg = ' " 結束時間 " 未填寫 請填寫'
              self.show_week_overlap = true
              item.show_overlap = true
            } else if (!item.amount || !item.amount === 0) {
              msg = ' " 數量上限 " 未填寫 請填寫'
              self.show_week_overlap = true
              item.show_overlap = true
            } else if (item.rule_start_time > item.rule_end_time) {
              msg = '開始時間大於結束時間'
              self.show_week_overlap = true
              item.show_overlap = true
            } else {
              if (item.is_enabled === 1 || item.is_enabled === '1') {
                const firstTime = {
                  start: item.rule_start_time,
                  end: item.rule_end_time
                }
                for (let step = self.rule_week_list.length - 1; step > wi; step--) {
                  if (self.rule_week_list[step].is_enabled === 1 || self.rule_week_list[step].is_enabled === '1') {
                    if (self.rule_week_list[step].delivery_type === item.delivery_type || self.rule_week_list[step].delivery_type === 0 || item.delivery_type === 0) {
                      if (Number(item.rule_day) === Number(self.rule_week_list[step].rule_day)) {
                        const compareTime = {
                          start: self.rule_week_list[step].rule_start_time,
                          end: self.rule_week_list[step].rule_end_time
                        }
                        if (self.overlappingTime(firstTime, compareTime)) {
                          console.log('here')
                          console.log(firstTime)
                          console.log(compareTime)
                          console.log(self.rule_week_list[step].amount)
                          console.log(item.amount)
                          console.log(wi)
                          console.log(step)
                          // 時間有發生重疊
                          msg = ''
                          self.show_week_overlap = true
                          self.rule_week_list[wi].show_overlap = true
                          self.rule_week_list[step].show_overlap = true
                          self.checkedFormEvnet()
                        }
                      }
                    }
                  }
                }
              }
            }
          })
        }
        self.getToast(msg)
        if (!this.show_section_overlap) {
          self.submit()
        }
      }
    },
    getToast (msg) {
      if (!msg) return
      this.$notify({
        title: '設定格式重複',
        text: msg,
        duration: 3000,
        type: 'danger',
        width: 400
      })
    },
    checkedFormEvnet () {
      this.checkedForm = true
      this.checkedFormModal = true
    },
    submit () {
      const rName = this.$route.name
      const data = {
        brand_id: this.brandSelect.value,
        store_id: this.storeSelect.value,
        item_list: []
      }
      if (this.name) data.name = this.name
      else data.name = ' '
      if (this.description) data.description = this.description
      else data.description = ' '

      this.rule_section_list.forEach(function (item) {
        const obj = {
          delivery_type: Number(item.delivery_type),
          src_type: Number(item.src_type),
          rule_type: 1,
          rule_start_date: item.sectionTime.start.time,
          rule_end_date: item.sectionTime.end.time,
          rule_start_time: item.rule_start_time + ':00',
          rule_end_time: item.rule_end_time + ':59',
          amount: Number(item.amount),
          is_enabled: Number(item.is_enabled)
        }
        data.item_list.push(obj)
      })
      this.rule_week_list.forEach(function (item) {
        const obj = {
          delivery_type: Number(item.delivery_type),
          src_type: Number(item.src_type),
          rule_type: 2,
          rule_day: item.rule_day,
          rule_start_time: item.rule_start_time,
          rule_end_time: item.rule_end_time,
          amount: Number(item.amount),
          is_enabled: Number(item.is_enabled)
        }
        data.item_list.push(obj)
      })

      if (rName === 'crLimitScheduleItem') this.crLimitSchedule(data)
      else if (rName === 'upLimitScheduleItem') this.crLimitSchedule(data)
    },
    overlappingTime (a, b) {
      const getMinutes = s => {
        const p = s.split(':').map(Number)
        return p[0] * 60 + p[1]
      }
      return getMinutes(a.end) > getMinutes(b.start) && getMinutes(b.end) > getMinutes(a.start)
    },
    dateRangeOverlaps (startA, endA, startB, endB) {
      if (startA === endA && startB === endB) {
        return startA === startB
      } else if (startA === endA && startB !== endB) {
        return startA >= startB && startA <= endB
      } else if (startA !== endA && startB === endB) {
        return startB >= startA && startB <= endA
      } else {
        return (startA <= endB && startB < endA)
      }
    },
    weekRange (startA, endA, weekday) {
      const start = startA.getDay() + 1
      const end = endA.getDay() + 1
      if (start < end) {
      // eg: 1 ~ 4
        if (weekday < start || weekday > end) {
          return false
        } else {
          return true
        }
      } else if (start > end) {
      // eg:4 ~ 1
        if (weekday < start && weekday > end) {
          return false
        } else {
          return true
        }
      } else {
      // eg: 3, 3
        if (weekday !== start) {
          return false
        } else {
          return true
        }
      }
    },
    crLimitSchedule (data) {
      var self = this
      const brandId = this.$route.query.brand_id
      const storeId = this.$route.query.store_id
      // let brandId = null
      // if (rName === 'crDisableSchedule') {
      //   brandId = this.brandSelect.value
      // } else if (rName === 'upDisableSchedule') {
      //   brandId = this.$route.query.brand_id
      // }
      // const storeId = this.storeSelect.value
      let connectType = 'post'
      var url = '/storeOrderAmountLimitSetting/create'
      // if (storeId !== 999999 && this.getRoleType === 10) url = '/store/' + storeId + '/productDisableScheduleSetting/group'
      if (this.$route.params.setting_id) {
        connectType = 'put'
        url = '/storeOrderAmountLimitSetting/' + this.$route.params.setting_id // 編輯
      }
      this.getDataH(connectType, url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '成功',
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          if (storeId) {
            self.$router.push('/limitedItemScheduleTable?brand=' + brandId + '&store=' + storeId)
          } else if (brandId) {
            self.$router.push('/limitedItemScheduleTable?brand=' + brandId)
          } else {
            self.$router.push('/limitedItemScheduleTable')
          }
          // if (self.getRoleType === 99 || self.getRoleType === 30) {
          //   self.$router.push('/disItemScheduleTable?brand=' + brandId)
          // } else if (self.getRoleType === 10 && storeId !== 999999) {
          //   self.$router.push('/disItemScheduleTable?store=' + storeId)
          // } else {
          //   self.$router.push('/disItemScheduleTable')
          // }
        }
      })
    },
    getAmountlimitSetting () {
      var self = this
      // var url = '/brand/' + this.$route.query.brand_id + '/productDisableScheduleSetting/group'
      // var url = '/brand/' + this.$route.query.brand_id + '/productDisableScheduleSetting/' + this.$route.params.setting_id
      // if (this.$route.query.usage_type === '2') url = '/store/' + this.$route.query.store_id + '/productDisableScheduleSetting/' + this.$route.params.setting_id
      var url = '/storeOrderAmountLimitSetting/' + this.$route.params.setting_id
      // if (this.$route.query.usage_type === '2') url = '/store/' + this.$route.query.store_id + '/productDisableScheduleSetting/group/' + this.$route.params.setting_id
      // url = '/store/' + this.$route.query.store_id + '/productDisableScheduleSetting/' + this.$route.params.setting_id
      self.item_list = []
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          const sInfo = response.data.info
          self.brandSelect.value = sInfo.brand_id
          self.brandSelect.label = sInfo.brand_name
          self.storeSelect.value = sInfo.store_id
          self.storeSelect.label = sInfo.store_name
          self.name = sInfo.name
          self.description = sInfo.description
          sInfo.item_list.forEach(function (item, index) {
            if (item.rule_type === 1) {
              const obj = {
                rule_type: item.rule_type,
                rule_start_date: item.rule_start_date,
                rule_end_date: item.rule_end_date,
                rule_start_time: item.rule_start_time,
                rule_end_time: item.rule_end_time,
                amount: item.amount,
                is_enabled: item.is_enabled,
                sectionTime: {
                  start: {
                    time: item.rule_start_date
                  },
                  end: {
                    time: item.rule_end_date
                  }
                },
                show_overlap: false,
                src_type: item.src_type,
                delivery_type: item.delivery_type,
                endLimit: [
                  {
                    type: 'fromto',
                    from: moment().add(-1, 'day').format('YYYY-MM-DD')
                  }
                ],
                startLimit: [
                  {
                    type: 'fromto',
                    from: moment().add(-1, 'day').format('YYYY-MM-DD')
                  }
                ]
              }
              const sdate = new Date(item.rule_start_date)
              let startdate = new Date(sdate)
              startdate.setDate(startdate.getDate() - 1)
              obj.endLimit[0].from = startdate.toISOString().split('T')[0]
              self.rule_section_list.push(obj)
            } else if (item.rule_type === 2) {
              const obj = {
                rule_type: item.rule_type,
                rule_day: Number(item.rule_day),
                rule_start_time: item.rule_start_time,
                rule_end_time: item.rule_end_time,
                amount: item.amount,
                is_enabled: item.is_enabled,
                show_overlap: false,
                src_type: item.src_type,
                delivery_type: item.delivery_type,
                id: index
              }
              self.rule_week_list.push(obj)
            }
          })
        }
      })
    },
    getProductAlias () {
      var self = this
      var url = '/brand/' + this.$route.params.brand_id + '/productAliasSetting/' + this.$route.params.setting_id
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          const setting = response.data.setting
          self.vendor_custom_id = setting.vendor_custom_id
          self.alias_name = setting.item_list[0].name
          if (!setting.is_enabled) self.is_enabled = 0
        }
      })
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    checkSelectAll () {
      if (this.$route.name === 'upDisableSchedule') {
        return true
      } else if (this.$route.name === 'crDisableSchedule') {
        if (this.addStoresSetting.choose.length > 0) {
          return true
        } else {
          return false
        }
      }
    },
    storedeliveryInfo () {
      const self = this
      let deliveryArray = []
      this.store_deliveryInfo.forEach(deliveryI => {
        if (deliveryI.is_support === 1) {
          deliveryArray.push(self.deliveryTypeOption.find(function (delivery) { return delivery.value === deliveryI.delivery_type }))
        }
      })
      return deliveryArray
    },
    getDataH () {
      return this.$parent.getDataH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    },
    checkSettingText () {
      let text = ''
      if (this.up) {
        text = '更新'
      }
      if (this.up && this.checkedForm) {
        text = '確定更新'
      }
      if (!this.up) {
        text = '新增'
      }
      if (!this.up && this.checkedForm) {
        text = '確定新增'
      }
      return text
    }
  },
  watch: {
  },
  created () {
    // if (this.$route.name === 'crDisableSchedule') {
    //   if (this.$route.query.brand_id) {
    //     // this.brandSelect.value = this.$route.query.brand_id
    //   }
    // }
    if (this.$route.name === 'upLimitScheduleItem') {
      this.up = true
      this.getStoreLimitSetting(this.$route.query.brand_id)
      this.getStoreInfo(this.$route.query.store_id)
      this.getAmountlimitSetting()
    } else {
      this.getBrandBrief()
    }
  }
}
</script>
<style lang="sass">
$default-color: #e1456d
$light-gray: rgb(238, 238, 238)
.label-text-60-p
  font-size: 60% !important
.m-t-10
  margin-top: 10px !important
.m-b-5
  margin-bottom: 5px !important
.m-r-5
  margin-right: 5px !important
.m-r-20
  margin-right: 20px !important
.m-r-15
  margin-right: 15px !important
.m-t-64
  margin-top: 64px !important
.display-time
  font-family: "Source Sans Pro", "Helvetica Neue", Helvetica, Arial, sans-serif
  padding: 6px 12px !important
.multiselect__placeholder
  padding: 0px !important
.msl-search-list-input
  border: 1px solid #ddd
.msl-searchable-list__items
  border: 1px solid #ddd !important
.msl-searchable-list__item
  border-bottom: 1px solid #ddd !important
.left_store_sec
  float: left;
  width: calc(50% - 30px);
.middle_store_sec
  float: left;
  width: 40px;
  margin: 0px 4px;
.right_store_sec
  float: left;
  width: calc(50% - 30px);
.block-checkbox
  right: 0px
  position: absolute
  top: 3px
.card-title .block-checkbox
  top: 8px
.checkbox-visible, .checkbox-enable
  margin-left: 20px
.text-dark-gray
  color: #333 !important
.text-light-gray
  color: #666 !important
.text-13
  font-size: 13px !important
.text-14-4
  font-weight: normal
  font-size: 14.4px !important
.multiselect__single
  font-size: 14.4px !important
.msl-search-list-input
  font-size: 14.4px !important
.btn-option-show
  background: #ffffff
  border: 1px solid $default-color
  min-width: 100px
  font-size: 15px
  border-radius: 5px
  cursor: auto
input[type="checkbox"]
  margin-left: 0
  padding: 0
input[type=checkbox].css-checkbox
  position: absolute
  overflow: hidden
  clip: rect(0 0 0 0)
  height: 1px
  width: 1px
  margin: -1px
  padding: 0px
  border: 0
input[type=checkbox].css-checkbox+label.css-label
  padding-left: 22px
  height: 16px
  width: 16px
  display: inline-block
  line-height: 15px
  background-repeat: no-repeat
  background-position: 0 0
  font-size: 13px
  vertical-align: middle
  cursor: pointer
  opacity: 1
input[type=checkbox].css-checkbox+label.css-label:hover
  opacity: 0.5
input[type=checkbox].css-checkbox:checked+label.css-label
  background-position: 0 -17px
.css-label:not(.css-label-add)
  background-image: url(/static/img/checkbox.png)
  background-size: 16px
.css-label.css-label-add
  background-image: url(/static/img/checkbox-delete.png)
  background-size: 16px
input[type=checkbox].css-checkbox+label.css-label.disabled:hover
  opacity: 1
.delete-line
  text-decoration: line-through;
.box-border
  border-top: 1px solid #e1456d;;
.h3-title
  color: #e1456d;
  font-size: 24px;
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  background-color: #fff;
.hr-line
  position: absolute;
  width: 100%;
  display: inline-lock;
  border-top: 1px solid #e1456d;
  top: 19px;
small
  color: dimgrey
.menu-info
  min-height: 120px
  width: 100%
  text-align: center
  *
    padding: 0
    margin: 0
    line-height: 25px
.m-b-15
  margin-bottom: 15px !important
.btn-edit-all, .btn-del-all
  margin-right: 15px
  z-index: 100
.nav-page-back, .page-number, .nav-page-next, .nav-zoomIn, .nav-zoomOut
  display: none !important
.fn-gantt .leftPanel
  width: 100px !important
.fn-gantt .leftPanel .fn-wide, .fn-gantt .leftPanel .fn-wide .fn-label
  font-size: 14px
.fn-gantt .navigate
  padding: 10px 0 10px 10px !important
.overlap
  border: 2px solid #CE5743
@media screen and (max-width: 499px)
  .min-m-t-10
    margin-top: 25px
</style>
<style lang="sass" scoped>
  table.table-bordered tbody th, table.table-bordered tbody td
    vertical-align: middle
  .box-table
    border: 1px solid #DEDEDE
    padding: 2em
  input .vue__time-picker
    text-align: center !important
  .copy-block
    position: absolute
    z-index: 300
    left: 10px
  .min-w
    min-width: 7rem
  .p-0
    padding: 0
  .position-sticky
    position: sticky !important
    top: 0
    z-index: 10
  .position-relative
    position: relative !important
    overflow: auto
</style>



// WEBPACK FOOTER //
// LimScheduleProdTemp.vue?bfaff07e